import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { HttpClient } from '@angular/common/http';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-video-upload',
  templateUrl: './video-upload.component.html',
  styleUrls: ['./video-upload.component.css']
})
export class VideoUploadComponent implements OnInit {


  @ViewChild("uploadForm", { static: false }) uploadForm: ElementRef;

  filesToUpload: Array<File>;

  @Input() rowData: any;
  fileToUpload;
  @ViewChild('fileInput', { static: false }) fileInput: ElementRef;


  constructor(public dataService: DataService, private fb: FormBuilder, public http: HttpClient) {

    this.filesToUpload = [];
    console.log(this.rowData);

  }

  ngOnInit() {

  }



  // onFileChange(event) {
  //   let reader = new FileReader();
  //   if (event.target.files && event.target.files.length > 0) {
  //     let file = event.target.files[0];
  //     reader.readAsDataURL(file);
  //     reader.onload = () => {
  //       this.form.get('avatar').setValue({
  //         filename: file.name,
  //         filetype: file.type,
  //         value: reader.result.split(',')[1]
  //       })
  //     };
  //   }
  // }

  postMethod(files: FileList) {

    console.log(this.rowData);

    this.fileToUpload = files.item(0);
    const formData = new FormData();


    formData.append('file', this.fileToUpload, `${this.rowData.id}.mp4`);
    // formData.append('abc', "def");

    this.http.post(this.dataService.serverUrl + "video/upload", formData).subscribe((val: any) => {

      console.log(val);

      if (val.status) {
        alert("Video Solution Uploaded !");
        return
      }
      alert("Failed to Upload Video Solution !")

    });
    return false;
  }


  upload() {
    // alert("sadf")
    console.log(this.uploadForm);
    this.uploadForm.nativeElement.submit();

  }

}
